<template>
  <v-app id="app" style="overflow-x: hidden;">
    <v-main>
      <v-sheet class="ma-5 signup-page">
        <div class="text-h1 text-center mb-5" style="font-weight: 600;">
          You Need to Register for
          <br />
          this Pass to Check-in!
        </div>
        <div class="text-body-2 mb-5">
          {{ venueName }} is a part of the following passes. If you have already
          signed up for a pass, scan this QR code from within your pass. If you
          have not, click on the link below to sign up for the pass!
        </div>
        <v-divider />
        <v-card
          v-for="partner in partners"
          :key="partner.id"
          class="mt-8 pa-1"
          elevation="24"
          rounded="xl"
        >
          
          <div class="d-flex flex-nowrap align-center pa-4">
            <v-img class="mr-4" max-width="74" :src="partner.logo"></v-img>
            <div class="align-self-start" style="line-height: 1;">
              <div class="text-h2 font-weight-bold mb-1">{{ partner.name }}</div>
             
              <a
                v-if="partner.website"
                class="font-weight-regular text-body-2 text-primary"
                :href="partner.website"
              >
                {{ partner.website }}
              </a>
            </div>
          </div>
          <template v-if="partner.passes">
            <v-row v-for="(pass, idx) in partner.passes" :key="pass.id">
              <v-col>
                <v-divider v-if="idx > 0" class="mx-4 mb-7" />
                <v-img
                  v-if="pass.media.length"
                  class="mx-4"
                  cover
                  height="152"
                  :src="pass.media[0].url"
                ></v-img>
                <div class="text-h2 px-4 pt-4 pb-0" style="font-weight: 600;">
                  {{ pass.name }}
                </div>
                <v-card-text>
                  <div>
                    <ul>
                      <li
                        v-for="(hl, idx) in pass.highlights"
                        :key="`hl-${idx}`"
                      >
                        <span v-html="hl"></span>
                      </li>
                    </ul>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    :href="pass.url"
                    rounded="pill"
                    size="large"
                    variant="flat"
                    width="100%"
                  >
                    Sign Up Now
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-sheet>
    </v-main>
  </v-app>
</template>

<script>
import { useTheme } from 'vuetify';
import themes from './themes.js';

export default {
  name: 'Signup',
  props: {
    unregisteredLinks: {
      type: Array,
      default: () => []
    },
    venueName: {
      type: String,
      default: 'This location'
    }
  },
  setup() {
    return { theme: useTheme() };
  },
  data() {
    return {
      partners: []
    };
  },
  created() {
    let currentPartner = {};

    this.unregisteredLinks.forEach(({ pass: { partner }, pass, url }) => {
      if (currentPartner.id !== partner.id) {
        currentPartner = { ...partner };
        currentPartner.website = this.addProtocol(partner.website);
        currentPartner.passes = [];
        currentPartner.logo = this.getPartnerLogoByLocation(
          currentPartner,
          'Logo'
        )?.url;

        this.partners.push(currentPartner);
      }

      const currentPass = { ...pass };

      currentPass.url = this.addProtocol(url);

      currentPass.highlights = currentPass.highlights?.split('\n');

      currentPartner.passes.push(currentPass);
    });

    this.applyPrimaryColor();
  },
  methods: {
    
    applyPrimaryColor() {
      const themesRef = this.theme.themes;
      if (!themesRef?.value?.light) return;

      themesRef.value = {
        ...themesRef.value,
        light: {
          ...themesRef.value.light,
          colors: {
            ...themesRef.value.light.colors,
            primary: themes.ui.light.colors.primary
          }
        }
      };
    },
    addProtocol(link) {
      return !link || link.startsWith('http') ? link : `https://${link}`;
    },
    getPartnerLogoByLocation(partner, location) {
      const { media } = partner || {};
      return media?.length
        ? media.find(m => m.location === location && m.url)
        : {};
    }
  }
};
</script>

<style lang="scss">
.v-main,
.v-main__scroller {
  background-color: #ffffff;
}

.signup-page .v-divider {
  opacity: 1;
}

.signup-page .v-btn {
  --v-btn-size: 0.875rem;
  font-weight: 600;
}

</style>
